import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, Calendar } from 'lucide-react';
import { COMPANY } from '../config/siteContent';

/**
 * CTASection - light theme.
 * Sky gradient background panel that pops against the surrounding white sections.
 */
const CTASection = () => {
  return (
    <section
      id="schedule-demo"
      className="relative py-24 lg:py-32 overflow-hidden bg-bg-canvas"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.7 }}
        className="relative max-w-5xl mx-auto px-6 lg:px-8"
      >
        <div
          className="relative rounded-3xl p-10 sm:p-14 lg:p-20 text-center overflow-hidden shadow-lifted"
          style={{
            background:
              'linear-gradient(135deg, #37ACE4 0%, #0EA5E9 50%, #0284C7 100%)',
          }}
        >
          {/* Decorative blobs */}
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" />

          <div className="relative">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 font-mono text-[11px] font-semibold text-white uppercase tracking-widest mb-6">
              Ready to Connect?
            </span>

            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-6 tracking-[-0.02em] leading-[1.05] text-balance">
              Let's get your business{' '}
              <span className="italic font-bold">talking to everyone.</span>
            </h2>

            <p className="text-lg text-white/90 max-w-2xl mx-auto mb-10 text-pretty">
              See iConnect in action. Book a 10-minute demo and we'll show you
              how to onboard your first trading partner this week.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-accent-primary font-semibold text-[15px] px-7 py-3.5 rounded-[10px] hover:bg-white hover:scale-[1.02] hover:shadow-2xl transition-all group"
              >
                <Calendar size={16} />
                Schedule a Demo
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
              <a
                href={`tel:${COMPANY.phones.salesTollFree.replace(/\D/g, '')}`}
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-semibold text-[15px] px-7 py-3.5 rounded-[10px] hover:bg-white/20 transition-all"
              >
                <MessageCircle size={16} />
                Call Sales: {COMPANY.phones.salesTollFree}
              </a>
            </div>

            <p className="mt-6 text-xs text-white/70">
              ✓ 10-minute call · ✓ Tailored to your stack · ✓ No obligation
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
